module.exports = __webpack_public_path__ + "static/media/Oswald-Light.fb3af9a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-Light.ttf
// module id = 6695
// module chunks = 2